/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Få Bumble",
      "Godta alle",
      "Administrer valg",
      "Cookies-reglement",
      "Gå tilbake",
      "Feil telefonnummer",
      "© {{current_year}} Bumble | Alle rettigheter forbeholdes",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Om",
      "Ambassadører",
      "The Buzz",
      "Denne siden benytter seg av cookies. Du godkjenner cookies med mindre du endrer innstillingene dine.",
      "Last ned appen",
      "Last ned for Android",
      "Last ned for iOS",
      "Vi beklager, vi kunne ikke finne siden du leter etter.",
      "Logg inn",
      "Bli med",
      "Bli med på Bumble!",
      "Oops, det oppsto en feil"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dager"
            ],
            "singular": [
                  "dag"
            ]
      },
      "hour": {
            "plural": [
                  "timer"
            ],
            "singular": [
                  "time"
            ]
      },
      "minute": {
            "plural": [
                  "minutter"
            ],
            "singular": [
                  "minutt"
            ]
      },
      "month": {
            "plural": [
                  "måneder"
            ],
            "singular": [
                  "måned"
            ]
      },
      "second": {
            "plural": [
                  "sekunder"
            ],
            "singular": [
                  "sekund"
            ]
      },
      "year": {
            "plural": [
                  "år"
            ],
            "singular": [
                  "år"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
